import React from 'react';
import { EditButton } from 'react-admin';
import { ActionsContainer, ReplacementButton } from '../../../components';

const ShowActions = (props) => {
  return (
    <ActionsContainer {...props}>
      <EditButton />
      <ReplacementButton />
    </ActionsContainer>
  );
};

export default ShowActions;
